import React from 'react'

import { Modal } from 'passiv-components'

const renderPortal = ({ display, errorText, onClickSuccess, onToggleModal }) => {
  return display === 'password-errors'
    ? () => (
        <Modal
          open={true}
          id="modal-password-errors"
          type="alert"
          title="Something’s wrong"
          text={errorText}
          buttons={[
            {
              name: 'ok',
              text: 'Ok',
              onClick: () => onToggleModal({ id: '' })
            }
          ]}
        />
      )
    : display === 'success'
    ? () => (
        <Modal
          id="modal-password-success"
          open={true}
          type="info"
          title="Success"
          text="Your password has been successfully reset." // todo: Or login to our App (iOS link / Android link)
          buttons={[
            {
              name: 'ok',
              text: 'Ok',
              onClick: onClickSuccess
            }
          ]}
        />
      )
    : null
}

export default renderPortal
